import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "unlogged-area--header" }
const _hoisted_2 = { href: "/" }
const _hoisted_3 = ["alt", "src"]

import TopBar from '@/components/common/layoutWrappers/HeaderBar.vue';
import useTranslations from '@/composables/useTranslations';
import helpers from '@/helpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'UnloggedAreaHeader',
  setup(__props) {

const {translate: t} = useTranslations();
const logoImgUrl = helpers.url.outerUrl('/files/public/Logo/OuterLogo.png');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TopBar, null, {
      logo: _withCtx(() => [
        _createElementVNode("a", _hoisted_2, [
          _createElementVNode("img", {
            class: "logo-image",
            alt: _unref(t)('Menu.HomePage'),
            src: _unref(logoImgUrl)
          }, null, 8, _hoisted_3)
        ])
      ]),
      menu: _withCtx(() => [...(_cache[0] || (_cache[0] = []))]),
      actions: _withCtx(() => [...(_cache[1] || (_cache[1] = []))]),
      _: 1
    })
  ]))
}
}

})